import request from '@/utils/request'

export function getInfo() {
  return request({
    url: '/user/info',
    method: 'get',
  })
}

export function getGoldBeanList(){
  return request({
    url: '/user/getGoldBeanList',
    method:'post',
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js